// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__2nGcr","file":"styles_file__2zYxO"};